module.exports = __webpack_public_path__ + "static/snakehips2-fe6cfc7535dea67a33f8035df7039690.png";